import { ToastAlertTypes } from '@genial/components';

export const screenName = 'aplicacao-meus-clientes';
export const screenNameSimplifiedFlow = 'aplicacao-meus-clientes-direto';

export const defaultErrorMessageApplication: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Ocorreu um erro ao enviar a boleta, verifique sua conexão com a internet e tente novamente em instantes.',
];
